import { NotificationBars } from 'presentation/ui/components/notification-bars/NotificationBars';
import { FormLayout } from 'presentation/ui/layouts/form-layout/FormLayout';
import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { NotificationBar } from 'presentation/ui/components/notification-bar/NotificationBar';
import { NotificationLevel } from 'presentation/ui/components/notification-bar/NotificationLevel';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { FormLayoutSection } from 'presentation/ui/layouts/form-layout/form-layout-section/FormLayoutSection';
import { FormLayoutSectionAlign } from 'presentation/ui/layouts/form-layout/FormLayoutSectionAlign';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';
import { InputFile } from 'presentation/ui/partials/input/input-file/input-file/InputFile';
import { Label } from 'presentation/ui/partials/input/label/Label';
import { ButtonSecondary } from 'presentation/ui/partials/button/button-secondary/ButtonSecondary';

export interface DocumentAddFormStep1Props {
	onChange: (files: Array<File>) => void;
	onClickNext: () => void;
	onClickPrevious?: () => void;
	files?: File[];
	invalid?: boolean;
}

export const DocumentAddFormStep1 = (props: DocumentAddFormStep1Props): JSX.Element => {
	const { onChange, onClickNext, onClickPrevious, files = null, invalid = false } = props;

	const l10nContext = useContext(L10nContext);

	const notification = !invalid ?
		null :
		<NotificationBar
			level={NotificationLevel.LEVEL_ERROR}
			message={`${l10nContext.translate('view.documents.modal.action.addDocument.notificationError', 'Dokument(e) darf nicht leer sein')}`}
		/>;

	const renderButtonPrevious = onClickPrevious ? 
		<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FLEX}>
			<ButtonSecondary
				buttonText={l10nContext.translate('common.button.back', 'Zurück')}
				onClick={onClickPrevious}
			/>
		</ColumnLayoutSection> : null;

	return (
		<FormLayout align={FormLayoutSectionAlign.ALIGN_HORIZONTAL} onSubmit={onClickNext}>
			<NotificationBars>
				{notification}
			</NotificationBars>

			<FormLayoutSection>
				<Label label={`${l10nContext.translate('view.documents.modal.action.addDocument.file', 'Datei(en)')}*`} alignTop>

					<InputFile
						cachedFiles={files}
						onchange={onChange}
					/>

				</Label>
			</FormLayoutSection>

			<FormLayoutSection align={FormLayoutSectionAlign.ALIGN_BOTTOM}>
				<ColumnLayout mode={ColumnLayoutMode.ALIGN_RIGHT}>
					{renderButtonPrevious}
					<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
						<ButtonPrimary
							buttonText={l10nContext.translate('common.button.next', 'Weiter')}
							type="submit"
						/>
					</ColumnLayoutSection>
				</ColumnLayout>
			</FormLayoutSection>
		</FormLayout>
	);
};
